import React from 'react';
import { Instagram, ExternalLink } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const INSTAGRAM_USERNAME = 'icg.hannover';
const INSTAGRAM_URL = `https://instagram.com/${INSTAGRAM_USERNAME}`;

const placeholderPosts = [
  {
    id: 1,
    image: 'https://customer-assets-v7afamib.emergentagent.net/job_19aead6b-8655-4d59-bd82-6868e26d577e/artifacts/1fcb91006c2c5fcb_image.png',
    alt: 'Nur Jesus rettet',
  },
  {
    id: 2,
    image: 'https://static.prod-images.emergentagent.com/jobs/19aead6b-8655-4d59-bd82-6868e26d577e/images/98988b47c7e366d0e2c9e9ea790ae7d72b24aa1cbf6e1e8290e2351d69744ba2.jpeg',
    alt: 'Du bist willkommen',
  },
  {
    id: 3,
    image: 'https://static.prod-images.emergentagent.com/jobs/19aead6b-8655-4d59-bd82-6868e26d577e/images/7755bfa267e70ec2e998c15056a7c2fc94de94d67a251875d897fea5b0056490.jpeg',
    alt: 'Johannes 3:16',
  },
  {
    id: 4,
    image: 'https://static.prod-images.emergentagent.com/jobs/19aead6b-8655-4d59-bd82-6868e26d577e/images/0508acf7420bdc2d4b5c2680002b270582ae997f00e9a1f641ab5a0fe074818b.jpeg',
    alt: 'Gemeinsam stark',
  },
  {
    id: 5,
    image: 'https://static.prod-images.emergentagent.com/jobs/19aead6b-8655-4d59-bd82-6868e26d577e/images/768faa37dbb72f8ac5ba30611d6c850d5dc4bc9fdc1c8c167f0a190fc85e9fb6.jpeg',
    alt: 'Psalm 23:1',
  },
  {
    id: 6,
    image: 'https://static.prod-images.emergentagent.com/jobs/19aead6b-8655-4d59-bd82-6868e26d577e/images/49517699910a29ecd754e1d168cb32837505c6116328393c8ca034b2370728ec.jpeg',
    alt: 'Gott ist treu',
  },
];

const InstagramFeed = () => {
  const { t } = useLanguage();
  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-3 mb-4">
            <Instagram className="w-7 h-7 text-pink-500" />
            <span className="text-lg font-semibold text-gray-600">@{INSTAGRAM_USERNAME}</span>
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            {t('instagram.follow')}
          </h2>
          <p className="text-base md:text-lg text-gray-600 max-w-2xl mx-auto">
            {t('instagram.subtitle')}
          </p>
        </div>

        {/* Instagram Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 max-w-6xl mx-auto">
          {placeholderPosts.map((post) => (
            <a
              key={post.id}
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`instagram-post-${post.id}`}
              className="group relative aspect-square rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all"
            >
              <img
                src={post.image}
                alt={post.alt}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-colors flex items-center justify-center">
                <Instagram className="w-8 h-8 text-white opacity-0 group-hover:opacity-100 transition-opacity" />
              </div>
            </a>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-10">
          <a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="instagram-follow-btn"
            className="inline-flex items-center gap-3 px-8 py-4 bg-gradient-to-r from-purple-600 via-pink-500 to-orange-400 
                       text-white rounded-xl font-semibold hover:shadow-xl hover:scale-105 transition-all text-lg"
          >
            <Instagram className="w-5 h-5" />
            {t('instagram.cta')}
            <ExternalLink className="w-4 h-4" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default InstagramFeed;
